import type { ContentEventStep, ContentEventStepStatus, ErrorContext } from "@storyboard/web-client";
import { createContentEvent } from "@storyboard/web-client";
import { transport } from "@/config";
import { appContext, deviceContext } from "@/models/apiContext";

/** Records one step of a content pipeline (record/process/upload), stamped with the ambient contexts. */
export function sendContentEvent({
  contentId,
  workspaceId,
  step,
  status,
  context,
  feedId,
  error,
}: {
  contentId: string;
  step: ContentEventStep;
  status: ContentEventStepStatus;
  workspaceId?: string;
  context?: object;
  feedId?: string;
  error?: Error;
}): Promise<void> {
  return createContentEvent(transport, {
    contentId,
    workspaceId,
    step,
    status,
    feedId,
    eventContext: context,
    timestamp: new Date().toISOString(),
    appContext,
    deviceContext,
    error: error as ErrorContext | undefined,
  });
}
